import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { Navbar, Nav, NavItem, NavDropdown, MenuItem } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBook, faGem, faImage, faQuoteLeft, faBoxes, faTachometerAlt, faStream, faUserTag, faUserEdit, faUserCog, faUsersCog, faCalendarAlt, faGavel, faHatWizard, faDungeon, faMoneyBill, faBan, faSignOutAlt, faArchive, faNewspaper, faUsers, faAddressBook, faAddressCard, faListOl, faRibbon, faChartLine, faBalanceScale, faQuestion, faAngleDoubleUp, faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { faDiscord, faCcPaypal } from '@fortawesome/free-brands-svg-icons';
import logo from './../images/ADTN-Logo-White-Clean.png'
import Avatar from '../common/Avatar';
import Notifications from '../Notifications/Notifications'
import {hasGroup, hasPermission} from "../common/permissions";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {isMobile} from 'react-device-detect';


class NavigationContainer extends Component {

    render() {
        return (
            <Navbar collapseOnSelect className="navbar-adt-wrapper navbar-adt">
                <Navbar.Header>
                    <Navbar.Brand>
                        <LinkContainer to="/" exact>
                            <NavLink to="/">
                                <img alt="Addiction" src={logo} />
                            </NavLink>
                        </LinkContainer>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav>
                        <NavDropdown eventKey={1} title="Addiction" id="addiction-nav-dropdown" noCaret>
                            {!hasGroup('Member', this.props.auth.groups) ? (
                                <LinkContainer to="/apply">
                                    <MenuItem eventKey={1.1}><FontAwesomeIcon className="text-primary" icon={faAddressCard} fixedWidth/> Apply to Join</MenuItem>
                                </LinkContainer>
                            ) : ('')}
                            {!hasGroup('Member', this.props.auth.groups) ? (
                                <MenuItem divider />
                            ) : ('')}
                            <LinkContainer to="/news">
                                <MenuItem eventKey={1.2}><FontAwesomeIcon className="text-primary" icon={faNewspaper} fixedWidth /> News</MenuItem>
                            </LinkContainer>
                            {
                            isMobile ? (
                                
                                <LinkContainer to="/users">
                                    <MenuItem eventKey={1.10}><FontAwesomeIcon className="text-primary" icon={faUsers} fixedWidth /> Users Online</MenuItem>
                                </LinkContainer>
                            ) : null
                            }
                            {
                                isMobile ? (
                                <LinkContainer to="/activity">
                                    <MenuItem eventKey={1.11}><FontAwesomeIcon className="text-primary" icon={faStream} fixedWidth /> Activity Feed</MenuItem>
                                </LinkContainer>                                
                                
                            ) : null
                            }
                            <LinkContainer to="/roster">
                                <MenuItem eventKey={1.3}><FontAwesomeIcon className="text-primary" icon={faUsers} fixedWidth /> Roster</MenuItem>
                            </LinkContainer>
                            <MenuItem divider />
                            {hasGroup('Member', this.props.auth.groups) ?
                                (
                                    <LinkContainer to="/recruitment">
                                        <MenuItem eventKey={1.4}><FontAwesomeIcon className="text-primary" icon={faAddressBook} fixedWidth/> Recruitment</MenuItem>
                                    </LinkContainer>
                                ) : (
                                    <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faAddressBook} fixedWidth/> Recruitment</MenuItem>
                                )
                            }
                            <MenuItem divider />
                            <MenuItem header>DKP</MenuItem>
                            <LinkContainer to="/dkp/standings">
                                <MenuItem eventKey={1.5}><FontAwesomeIcon className="text-primary" icon={faListOl} fixedWidth /> Standings</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/dkp/events">
                                <MenuItem eventKey={1.6}><FontAwesomeIcon className="text-primary" icon={faGavel} fixedWidth /> Event History</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/dkp/items">
                                <MenuItem eventKey={1.7}><FontAwesomeIcon className="text-primary" icon={faHatWizard} fixedWidth /> Item History</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/dkp/resources">
                                <MenuItem eventKey={1.8}><FontAwesomeIcon className="text-primary" icon={faGem} fixedWidth /> Resources</MenuItem>
                            </LinkContainer>
                            <MenuItem divider />
                            <MenuItem eventKey={1.9} onClick={() => window.open("https://discord.gg/addictguild", "_blank")}><FontAwesomeIcon className="text-primary" icon={faDiscord} fixedWidth /> Discord</MenuItem>
                        </NavDropdown>
                        <LinkContainer disabled to="/forum">
                            <NavItem href="/forum">
                                FORUM
                            </NavItem>
                        </LinkContainer>
                        <NavDropdown eventKey={2} title="Media" id="media-nav-dropdown" noCaret>
                            <LinkContainer to="/codex">
                                <MenuItem><FontAwesomeIcon className="text-primary" icon={faBook} fixedWidth /> Codex</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/screenshots">
                                <MenuItem><FontAwesomeIcon className="text-primary" icon={faImage} fixedWidth /> Screenshots</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/quotes">
                                <MenuItem><FontAwesomeIcon className="text-primary" icon={faQuoteLeft} fixedWidth /> Member Quotes</MenuItem>
                            </LinkContainer>
                        </NavDropdown>
                        <NavDropdown eventKey={3} title="About" id="about-nav-dropdown" noCaret>
                            <LinkContainer to="/about/faq">
                                <MenuItem ><FontAwesomeIcon className="text-primary" icon={faQuestion} fixedWidth /> FAQ</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/about/rules">
                                <MenuItem><FontAwesomeIcon className="text-primary" icon={faBalanceScale} fixedWidth /> Rules</MenuItem>
                            </LinkContainer>
                            <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faChartLine} fixedWidth /> History</MenuItem>
                            <MenuItem divider />
                            <LinkContainer to="/about/awards">
                                <MenuItem><FontAwesomeIcon className="text-primary" icon={faRibbon} fixedWidth /> Awards</MenuItem>
                            </LinkContainer>
                            <LinkContainer to="/about/ranks">
                                <MenuItem><FontAwesomeIcon className="text-primary" icon={faAngleDoubleUp} fixedWidth /> Ranks</MenuItem>
                            </LinkContainer>
                        </NavDropdown>
                        { hasGroup('Officer', this.props.auth.groups) ? (
                            <NavDropdown eventKey={4} title="Officer" id="officer-nav-dropdown" noCaret>
                                <MenuItem header>Guild Management</MenuItem>
                                { hasPermission('games.add_chapter', this.props.auth.permissions) ?
                                    (
                                    <LinkContainer to="/officer/chapters">
                                        <MenuItem><FontAwesomeIcon className="text-primary" icon={faBoxes} fixedWidth /> Chapters</MenuItem>
                                    </LinkContainer>
                                    ) : ( <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faBoxes} fixedWidth /> Chapters</MenuItem> )
                                }
                                <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faUsersCog} fixedWidth /> Members</MenuItem>
                                <LinkContainer to="/officer/awards">
                                    <MenuItem><FontAwesomeIcon className="text-primary" icon={faRibbon} fixedWidth /> Awards</MenuItem>
                                </LinkContainer>
                                <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faNewspaper} fixedWidth /> News</MenuItem>
                                <MenuItem header>Events & DKP</MenuItem>
                                <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faCalendarAlt} fixedWidth /> Calendar</MenuItem>
                                <LinkContainer to="/officer/events">
                                    <MenuItem><FontAwesomeIcon className="text-primary" icon={faGavel} fixedWidth /> Events</MenuItem>
                                </LinkContainer>
                                <LinkContainer to="/officer/locations">
                                    <MenuItem><FontAwesomeIcon className="text-primary" icon={faDungeon} fixedWidth /> Locations</MenuItem>
                                </LinkContainer>
                                <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faHatWizard} fixedWidth /> Items</MenuItem>
                                <LinkContainer to="/officer/resources">
                                    <MenuItem><FontAwesomeIcon className="text-primary" icon={faGem} fixedWidth /> Resources</MenuItem>
                                </LinkContainer>
                                <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faMoneyBill} fixedWidth /> Bonuses</MenuItem>
                                <MenuItem header>Website Administration</MenuItem>
                                <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faUsersCog} fixedWidth /> Users</MenuItem>
                                <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faEnvelope} fixedWidth /> Mass Email</MenuItem>
                                <MenuItem divider />
                                <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faArchive} fixedWidth /> Logs</MenuItem>
                                <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faBan} fixedWidth /> Bans</MenuItem>
                            </NavDropdown>
                        ) : ('')}
                    </Nav>
                    { !this.props.auth.loggedIn ?
                    (
                        <Nav pullRight>
                            <LinkContainer to="/login">
                                <NavItem
                                    eventKey={1}
                                    className="navbar-user"
                                >
                                    Log In
                                </NavItem>
                            </LinkContainer>
                            <LinkContainer to="/register">
                                <NavItem
                                    eventKey={2}
                                    className="navbar-user"
                                >
                                    Register
                                </NavItem>
                            </LinkContainer>
                        </Nav>
                    ) : (
                        <Nav pullRight>
                            <NavItem href="https://www.paypal.me/jamesgardiner87" target="_blank">
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="donate">Donate to Addiction</Tooltip>}>
                                    <FontAwesomeIcon icon={faCcPaypal} fixedWidth/>
                                </OverlayTrigger>
                            </NavItem>
                            <Notifications />
                            <NavDropdown
                                eventKey={3}
                                id="avatar-nav-dropdown"
                                title= {<Avatar image={this.props.currentUser.avatar} rank={this.props.currentUser.rank} width="40" height="40" />}
                                className="navbar-avatar"
                            >
                                {hasGroup('Member', this.props.auth.groups) ?
                                    (
                                        <LinkContainer to="/dashboard">
                                            <MenuItem><FontAwesomeIcon className="text-primary" icon={faTachometerAlt} fixedWidth/> Dashboard</MenuItem>
                                        </LinkContainer>
                                    ) : (
                                        <MenuItem disabled><FontAwesomeIcon className="text-primary" icon={faTachometerAlt} fixedWidth/> Dashboard</MenuItem>
                                    )
                                }
                                <LinkContainer to="/applications">
                                    <MenuItem><FontAwesomeIcon className="text-primary" icon={faUserTag} fixedWidth /> Applications</MenuItem>
                                </LinkContainer>
                                <LinkContainer to="/profile">
                                    <MenuItem><FontAwesomeIcon className="text-primary" icon={faUserEdit} fixedWidth /> Edit Profile</MenuItem>
                                </LinkContainer>
                                <LinkContainer to="/settings">
                                    <MenuItem><FontAwesomeIcon className="text-primary" icon={faUserCog} fixedWidth /> Settings</MenuItem>
                                </LinkContainer>
                                <MenuItem divider />
                                <MenuItem onClick={() => this.props.logout()}><FontAwesomeIcon className="text-primary" icon={faSignOutAlt} fixedWidth /> Logout</MenuItem>
                            </NavDropdown>
                        </Nav>
                    )}
                </Navbar.Collapse>
            
            </Navbar>
        );
    }
}

export default NavigationContainer;


// WEBPACK FOOTER //
// ./src/App/NavigationContainer.js